import { metricColumn } from './metrics/directions.js';

let overlapHistory = [];
let slopeHistory = [];
let orthogonalityHistory = [];
let numCrossingsHistory = [];
let crossingAngleHistory = [];
let numRibbonsHistory = []
let widthVarianceHistory = [];
let mutualInfoHistory = [];

export function resetHistories() {
    overlapHistory = [];
    slopeHistory = [];
    orthogonalityHistory = [];
    numCrossingsHistory = [];
    crossingAngleHistory = [];
    numRibbonsHistory = []
    widthVarianceHistory = [];
    mutualInfoHistory = [];
    updateAllSparklines();
}

export function addValuesToHistories(qms, version) {
    overlapHistory.push([overlapHistory.length, qms.overlap]);
    slopeHistory.push([slopeHistory.length, qms.slope]);
    orthogonalityHistory.push([orthogonalityHistory.length, qms.orthogonality]);
    numCrossingsHistory.push([numCrossingsHistory.length, qms.crossings]);
    crossingAngleHistory.push([crossingAngleHistory.length, qms[metricColumn('crossingAngle', version)]]);
    numRibbonsHistory.push([numRibbonsHistory.length, qms.relNumRibbons]);
    widthVarianceHistory.push([widthVarianceHistory.length, qms.widthSd]);
    mutualInfoHistory.push([mutualInfoHistory.length, qms.mutualInfo]);
    updateAllSparklines();
}

function updateAllSparklines() {
    sparkline('#qm-overlap-sparkline', overlapHistory);
    sparkline('#qm-slope-sparkline', slopeHistory);
    sparkline('#qm-orthogonality-sparkline', orthogonalityHistory);
    sparkline('#qm-numcrossings-sparkline', numCrossingsHistory);
    sparkline('#qm-crossingangle-sparkline', crossingAngleHistory);
    sparkline('#qm-numribbons-sparkline', numRibbonsHistory);
    sparkline('#qm-widthvariance-sparkline', widthVarianceHistory);
    sparkline('#qm-mutualinfo-sparkline', mutualInfoHistory);
}

const sparkline = (container, data, options) => {
    const defaults = {
        scale: {
            x: d3.scale.linear(),
            y: d3.scale.linear()
        },
        size: [130, 20],
        style: {
            stroke: "rgb(60, 120, 240)",
            strokeWidth: 1
        },
        value: {
            x: d => d[0],
            y: d => d[1]
        }
    };

    // Apply defaults to the given options.
    options = $.extend(true, defaults, options);

    d3.select(container).selectAll("*").remove();

    // Add an SVG object to the given container.
    let svg = d3
        .select(container)
        .append("svg")
        .classed("sparkline", true)
        .classed("sparkline-svg", true)
        .attr("width", options.size[0])
        .attr("height", options.size[1]);

    let g = svg
        .append("g")
        .classed("sparkline", true)
        .classed("sparkline-group", true);

    let xScale = options.scale.x.range([0, options.size[0]]).domain(d3.extent(data, options.value.x));

    let yScale = options.scale.y.range([options.size[1], 0]).domain(d3.extent(data, options.value.y));

    // Create the line generator function.
    let line = d3.svg
        .line()
        .x(d => xScale(options.value.x(d)))
        .y(d => yScale(options.value.y(d)));

    // Finally, draw the path object.
    let path = g
        .append("path")
        .classed("sparkline", true)
        .classed("sparkline-path", true)
        .datum(data)
        .attr("d", line)
        .style("fill", "none")
        .style("stroke", options.style.stroke)
        .style("stroke-width", options.style.strokeWidth);

    return path;
};